import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../../../../reducers/modalReducer';
import type { SaveState } from '../../utils/saveGate';

type Props = {
  saveState: SaveState;
  canSave: boolean;
  isBusy?: boolean;
  confirm: () => Promise<boolean | void>;
};

export const useClosureConfirmingSave = ({ saveState, canSave, isBusy = false, confirm }: Props) => {
  const dispatch = useDispatch();
  const [isConfirmingClosure, setIsConfirmingClosure] = useState(false);
  const { save, isPending, requiresProductClosureConfirmation } = saveState;

  const handleSave = async () => {
    if (!save || isPending || !canSave) return;

    if (requiresProductClosureConfirmation) {
      setIsConfirmingClosure(true);
      return;
    }

    await save();
  };

  const confirmClosure = async () => {
    if (isBusy) return;

    const saved = await confirm();
    if (saved !== false) {
      setIsConfirmingClosure(false);
    }
  };

  const cancelClosure = () => {
    setIsConfirmingClosure(false);
    dispatch(closeModal());
  };

  return { handleSave, isConfirmingClosure, confirmClosure, cancelClosure };
};
